import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import HowItWorksDesktopOnlyModal from '../components/HowItWorksDesktopOnlyModal';

const Ctx = createContext(null);

export function HowItWorksModalProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openDesktopOnlyModal = useCallback(() => setOpen(true), []);
  const close = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({ openDesktopOnlyModal }),
    [openDesktopOnlyModal]
  );

  return (
    <Ctx.Provider value={value}>
      {children}
      <HowItWorksDesktopOnlyModal open={open} onClose={close} />
    </Ctx.Provider>
  );
}

/**
 * @returns {{ openDesktopOnlyModal: () => void }}
 */
export function useHowItWorksDesktopModal() {
  const v = useContext(Ctx);
  if (!v) {
    return { openDesktopOnlyModal: () => {} };
  }
  return v;
}
